export default __webpack_public_path__ + "e5ba8622e55bf720fda00f35f1335d6b.png";